<template>
    <base-container ref="container" :isLoading="loading" style="overflow: hidden">
        <el-tabs type="border-card" v-model="roomId" style="height: 100%" tab-position="left">
            <el-tab-pane :label="res.name" :name="res.id" v-for="res in resList" :key="res.id">
                <el-row style="height: 100%" type="flex" align="middle">
                    <el-col style="height: 100%" :span="12">
                        <artisan-group style="height: 100%" title="选择日期">
                            <el-calendar v-model="selDate">
                                <template #dateCell="{ date, data }">
                                    <div class="day-container">
                                        <div class="day-content">{{ data.day.split("-")[2] }}</div>
                                        <i v-if="data.isSelected" class="day-select el-icon-success"></i>
                                        <div v-if="scheduleMap[data.day] && scheduleMap[data.day].length
                                            " class="day-schedule day-schedule-success">
                                            <!-- <span style="margin-left: 2px" v-if="data.day == recommendDate">荐</span> -->
                                        </div>
                                        <!-- </template> -->
                                    </div>
                                </template>
                            </el-calendar>
                        </artisan-group>
                    </el-col>
                    <el-col :span="12" style="height: 100%; border-left: 1px #409eff solid">
                        <artisan-group style="height: 100%" title="预约资源">
                            <template #header>
                                <el-row type="flex" justify="space-between" align="middle">
                                    <div>
                                        <span>预约资源</span>
                                    </div>

                                    <span>
                                        <!-- <el-checkbox style="margin-right: 5px" size="small" v-model="isForce">
                                            强制预约
                                        </el-checkbox> -->
                                        <el-button type="primary" size="mini" @click="confirmReserve" icon="el-icon-check">
                                            确认改约
                                        </el-button>
                                    </span>
                                </el-row>
                            </template>
                            <el-row v-if="scheduleMap[scheduleDate] && scheduleMap[scheduleDate].length
                                " style="overflow-y: auto">
                                <el-col :span="8" v-for="(schedule, i) in scheduleMap[scheduleDate]" :key="i"
                                    class="padding-v7">
                                    <el-radio size="mini" border v-model="scheduleId" :disabled="reservable(schedule)"
                                        :label="schedule.id">
                                        <b>{{ schedule.startPoint }}-{{ schedule.endPoint }}</b>
                                        <span>
                                            (
                                            <span class="color-success">{{ schedule.resCount }}</span>
                                            <span>/</span>
                                            <span class="color-danger">{{
                                                schedule.totalCount
                                            }}</span>
                                            )
                                        </span>
                                    </el-radio>
                                </el-col>
                            </el-row>
                            <div v-else>
                                <el-empty description="暂无排班" :image-size="200"></el-empty>
                            </div>
                        </artisan-group>
                    </el-col>
                </el-row>
            </el-tab-pane>
        </el-tabs>
    </base-container>
</template>
  
<script>
import { getBillsSchedule, reserveChange } from "@/api/zl/reserve";
import moment from "moment";
export default {
    props: {
        bills: {
            type: Array,
            default: () => {
                return [];
            }
        },
        resDate: {
            type: String,
            default: "",
        },
        resId: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            selDate: this.resDate ? moment(this.resDate).toDate() : new Date(),
            scheduleId: "",
            resList: [],
            roomId: this.resId,
            isForce: false,
            loading: false,
            recommendDate: "",
        };
    },
    computed: {
        scheduleMap() {
            let res = this.resList.find((c) => c.id == this.roomId);
            let map = {};
            if (res && res.schedules.length) {
                res.schedules.forEach((c) => {
                    if (map[c.scheduleDate]) {
                        map[c.scheduleDate].push(c);
                    } else {
                        map[c.scheduleDate] = [c];
                    }
                });
            }
            return map;
        },
        scheduleDate() {
            return moment(this.selDate).format("YYYY-MM-DD");
        },
    },
    mounted() {
        this.loading = true;
        getBillsSchedule(this.bills.map((b) => b.id).join(","))
            .then((res) => {
                this.resList = res.data.data;
                let room = this.resList.find((c) => c.id == this.roomId);
                if (!room) {
                    this.roomId = this.resList[0].id;
                }
                this.loading = false;
            })
            .catch(() => {
                this.loading = false;
            });
    },
    methods: {
        reservable(detail) {
            let able = false;
            let current = moment().format("YYYY-MM-DD");
            let point = moment().format("HH:mm");
            if (detail.scheduleDate == current) {
                able = detail.endPoint > point;
            } else if (detail.scheduleDate > current) {
                able = true;
            }
            if (able) {
                if (detail.status == "full") {
                    able = this.isForce;
                } else if (detail.status == "stop") {
                    able = false;
                }
            }
            let sum = 0;
            if (detail.numType == "average") {
                this.bills.forEach((b) => {
                    sum += b.numCount
                })
            } else {
                this.bills.forEach((b) => {
                    sum += b.expendCount
                })
            }
            if (detail.totalCount - detail.resCount < sum) {
                able = false
            }

            return !able;
        },
        confirmReserve() {
            if (!this.scheduleId) {
                this.$message({
                    type: "warning",
                    message: "请选择要预约的日期时段！",
                });
                return;
            }
            this.$refs.container.confirm({ msg: "确认预约？" }).then((res) => {
                this.loading = true;
                reserveChange({
                    billIds: this.bills.map((b) => b.id).join(","),
                    periodId: this.scheduleId,
                })
                    .then(() => {
                        this.$message({
                            type: "success",
                            message: "预约成功！",
                        });
                        this.$emit("reserved");
                        this.loading = false;
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            });
        },
    },
};
</script>
  
<style scoped>
::v-deep .el-tabs__content {
    height: 100%;
    padding: 0 0;
}

::v-deep .el-tab-pane {
    height: 100%;
    overflow-y: auto;
}

.head {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

::v-deep .el-drawer__wrapper {
    top: 32px !important;
}

::v-deep .el-table .disabledCheck .cell .el-checkbox__inner {
    display: none;
}

.matter_tool {
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 7px 0;
}

.el-table::before {
    height: 0;
}

.base-container {
    overflow: hidden;
}

::v-deep .el-calendar-day {
    height: auto;
}

.day-container {
    position: relative;
    height: 50px;
}

.day-content {
    height: 50px;
    line-height: 50px;
    text-align: center;
}

.day-select {
    display: block;
    position: absolute;
    bottom: 2px;
    right: 2px;
    height: 15px;
    color: #f56c6c;
}

.day-schedule {
    font-size: smaller;
    display: block;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 30px;
    height: 30px;
    line-height: 20px;
}

.day-schedule-danger {
    background-image: url("/img/triangle_danger.png");
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
}

.day-schedule-success {
    background-image: url("/img/triangle_success.png");
    background-repeat: no-repeat;
    background-size: cover;
    color: #fff;
}
</style>
  